import { render } from "./AddNotification.vue?vue&type=template&id=08d00a24&scoped=true"
import script from "./AddNotification.vue?vue&type=script&lang=js"
export * from "./AddNotification.vue?vue&type=script&lang=js"

import "./AddNotification.vue?vue&type=style&index=0&id=08d00a24&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d00a24"]])

export default __exports__